import { render, staticRenderFns } from "./settlement-type.vue?vue&type=template&id=3a12de00&scoped=true&"
import script from "./settlement-type.vue?vue&type=script&lang=js&"
export * from "./settlement-type.vue?vue&type=script&lang=js&"
import style0 from "./settlement-type.vue?vue&type=style&index=0&id=3a12de00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a12de00",
  null
  
)

export default component.exports